module.exports = __webpack_public_path__ + "static/femaleentrepreneurship-bb24d3a0424292affe7954c999a3ae4c.jpg";